var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Echart',{ref:"centreLeft2ChartRef",attrs:{"id":"centreLeft2Chart","options":_vm.options,"height":"360px","width":"100%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }